import { commonStyles } from 'styles/common.styles'

export const styles = {
	...commonStyles,
	container: {
		paddingTop: '3rem',
		paddingBottom: '3rem',
		paddingX: {
			xs: '1rem',
			sm: '2rem',
		},
	},
}
